import { useContext } from 'react'
import { AppFormContext } from '../components/Context/AppFormContextProvider'
import { AssetLayoutContext } from '../components/Context/AssetLayoutContextProvider'
import { DialogContextCtx } from '../components/Context/DialogContext'
import { FilesContext } from '../components/Context/FilesContextProvider'
import { FormSchemaAppDataContext } from '../components/Context/FormSchemaAppDataContext'
import { MainLayoutContext } from '../components/Context/MainLayoutContextProvider'
import { SpotlightSearchContext } from '../components/Context/SpotlightSearchContext'
import { ThemeContext } from '../components/Context/ThemeContextProvider'
import { UserClientsContext } from '../components/Context/UserClientsContextProvider'
import { WorkOrderChecklistRefsContext } from '../components/Context/WorkOrderChecklistRefsContext'
import { WorkshopLayoutContext } from '../components/Context/WorkshopLayoutContextProvider'

export function useMainLayoutContext() {
  return useContext(MainLayoutContext)
}

export function useThemeContext() {
  return useContext(ThemeContext)
}

export function useUserClientsContext() {
  return useContext(UserClientsContext)
}

export function useBoatLayoutContext() {
  return useContext(AssetLayoutContext)
}

export function useFilesContext() {
  return useContext(FilesContext)
}

export function useAppFormCtx() {
  return useContext(AppFormContext)
}

export function useWorkshopLayoutContext() {
  return useContext(WorkshopLayoutContext)
}
export function useDialogCtx() {
  return useContext(DialogContextCtx)
}
export function useSpotlightSearchContext() {
  return useContext(SpotlightSearchContext)
}
export function useFormSchemaAppDataContext() {
  return useContext(FormSchemaAppDataContext)
}
export function useWorkOrderChecklistRefsRegistry() {
  return useContext(WorkOrderChecklistRefsContext)
}
